import * as React from 'react';
import { timeStamp, currency } from '~/lib/formatters';
import Table from '~/common/components/Table';
import StyledButton from '~/common/controls/StyledButton';
import { PaycodeStatus } from '../../consts';

export default (props) => {
  const { onEdit, onReceipt, organizations, transactions, ...rest } = props;

  const handleEdit = (e, code) => {
    e.preventDefault();
    onEdit(code);
  };

  const handleReceipt = (e, code) => {
    e.preventDefault();
    onReceipt(code);
  };

  const columns = [
    {
      Header: 'Date',
      id: 'date',
      accessor: d => timeStamp(d.date),
    },
    {
      Header: 'Issued',
      id: 'limit',
      accessor: d => `$` + currency(d.amount),
    },
    {
      Header: 'Status',
      accessor: 'status',
    },
    {
      Header: 'Code',
      accessor: 'code',
    },
    {
      Header: 'Restriction',
      id: 'organization',
      accessor: (d) => {
        return organizations[d.organizationId] && organizations[d.organizationId].name;
      },
    },
    {
      Header: 'Note',
      accessor: 'note',
    },
    {
      Cell: (row) => {
        if (row.original.status === PaycodeStatus.ACTIVE) {
          return (
            <StyledButton onClick={(e) => handleEdit(e, row.original)} label="View" />
          );
        } else
        if (row.original.status === PaycodeStatus.COMPLETE) {
          const tx = row.original.transactionId ? transactions[row.original.transactionId] : null;

          if (tx && tx.receiptUrl) {
            return (
              <StyledButton onClick={(e) => handleReceipt(e, row.original)} label="Receipt" />
            );
          }
        }

        return null;
      }
    },
  ];

  return (
    <Table
      columns={columns}
      {...rest}
    />
  );
};
